import { t } from 'javascripts/utils/withTranslation';
import h from 'hyperscript';
import { LINGUATEC_VOICE_READER_DO_NOT_READ_CLASS } from 'javascripts/constants';

export const accessibilityText = {
  external: t('Extern:'),
  download: t('Download:'),
  mail: t('E-Mail:'),
  phone: t('Telefon:'),
  fax: t('Fax:'),
};

const targetBlankHint = t('Öffnet in neuem Fenster');

const removeAccessibilityPrefix = (text = '') =>
  Object.values(accessibilityText).reduce((currentText, prefix) => {
    const normalizedText = currentText.trim();

    if (normalizedText.startsWith(`${prefix} `)) {
      return normalizedText.slice(prefix.length + 1);
    }

    return normalizedText;
  }, text);

const removeTargetBlankHint = (text = '') => {
  const targetHint = `(${targetBlankHint})`;
  const normalizedText = text.trim();

  if (normalizedText.endsWith(targetHint)) {
    return normalizedText.slice(0, -targetHint.length).trim();
  }

  return normalizedText;
};

const getCleanOriginalText = (text = '') =>
  removeTargetBlankHint(removeAccessibilityPrefix(text));

export const linkModifier = [
  'external',
  'download',
  'mail',
  'mail-block',
  'external-block',
  'external-link-new-window',
  'download-block',
  'phone-block',
  'phone',
  'mail-block',
  'fax',
  'fax-block',
];

export default function addAccessibilityTextToLinkType($el, config) {
  const options = { type: 'external', ...config };

  const getElement = (className, fallback) =>
    className ? $el.querySelector(`.${className}`) : fallback;

  const $link = getElement(options.linkClassName, $el);
  const $text = getElement(options.linkTextClassName, $el);
  let originalText = $text?.textContent || '';
  if ($text) {
    const $clone = $text.cloneNode(true);
    // Remove accessibility texts as we add new ones here
    $clone
      .querySelectorAll('.u-hidden-visually')
      .forEach((span) => span.remove());
    originalText = $clone.textContent;
  }
  const addAccessabilityText = accessibilityText[options.type];
  const addTargetText =
    $text && $link.getAttribute('target') === '_blank'
      ? ` (${targetBlankHint})`
      : '';

  if ($text) {
    $text.textContent = '';
    const $span = addAccessabilityText
      ? h(
          `span.u-hidden-visually.${LINGUATEC_VOICE_READER_DO_NOT_READ_CLASS}`,
          { 'data-nosnippet': 'true' },
          `${addAccessabilityText} `,
        )
      : null;
    const $targetSpan = addTargetText
      ? h(
          `span.u-hidden-visually.${LINGUATEC_VOICE_READER_DO_NOT_READ_CLASS}`,
          { 'data-nosnippet': 'true' },
          addTargetText,
        )
      : null;

    if ($span) $text.appendChild($span);
    $text.appendChild(document.createTextNode(`${originalText}`));
    if ($targetSpan) $text.appendChild($targetSpan);
  }
}

export const addAccessibilityTextToIconTitle = ($el, config) => {
  const options = { type: 'external', ...config };
  const $icon = $el.querySelector('.icon');

  if (!$icon) return;
  if ($icon.getAttribute('role') !== 'img') return;

  let $title = $icon.querySelector('title');
  if (!$title) {
    $title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
    $icon.insertBefore($title, $icon.firstChild);
  }

  const originalTitle = getCleanOriginalText($title.textContent || '');
  const addAccessabilityText = accessibilityText[options.type];
  const addTargetText =
    $el.getAttribute('target') === '_blank' ? ` (${targetBlankHint})` : '';

  $title.textContent = addAccessabilityText
    ? `${addAccessabilityText} ${originalTitle}${addTargetText}`.trim()
    : `${originalTitle}${addTargetText}`.trim();
};

// simple RTE Link

const query = `.link, ${linkModifier
  .map((modifier) => `.link-${modifier}, .link--${modifier}, .${modifier}`)
  .join(', ')}`;

document.querySelectorAll(query)?.forEach(($el) => {
  const classList = Array.from($el.classList);
  const matchedType = Object.keys(accessibilityText).find((key) =>
    classList.some((className) => className.includes(key)),
  );

  if (matchedType) {
    addAccessibilityTextToLinkType($el, { type: matchedType });
  }
});

// Icon Link

export const iconKeyMatcher = {
  external: ['external', 'bw-arrow-up-right-line'],
  download: ['download', 'bw-arrow-box-down-line'],
  mail: ['email', 'bw-email-line'],
  phone: ['telephone', 'bw-call-line'],
  fax: ['fax', 'bw-invite-line'],
};

export const getMatchFromIconClassList = (iconClassList) =>
  Object.keys(iconKeyMatcher).find((key) =>
    iconKeyMatcher[key].some((iconIdentifier) =>
      Array.from(iconClassList).some((className) =>
        className.includes(iconIdentifier),
      ),
    ),
  );

export const getMatchFromDomIcon = ($el) => {
  const $icon = $el.querySelector('.icon');
  if (!$icon) return null;

  return getMatchFromIconClassList($icon.classList);
};

document.querySelectorAll('.icon-link')?.forEach(($el) => {
  const matchedType = getMatchFromDomIcon($el);
  if (matchedType) {
    addAccessibilityTextToLinkType($el, {
      type: matchedType,
      linkTextClassName: 'icon-link__text',
    });
  }
});

document.querySelectorAll('.link-list__link')?.forEach(($el) => {
  const matchedType = getMatchFromDomIcon($el);
  if (matchedType) {
    addAccessibilityTextToLinkType($el, {
      type: matchedType,
      linkTextClassName: 'link-list__text',
    });
  }
});

document.querySelectorAll('a.button--icon')?.forEach(($el) => {
  const matchedType = getMatchFromDomIcon($el);
  if (matchedType) {
    addAccessibilityTextToIconTitle($el, {
      type: matchedType,
    });
  }
});
